import request from '@/utils/request';
import qs from 'qs'
export function pdfupload(params) {
    return request({
        url: 'pdf/upload/',
        method: 'post',
        data: params
    })
}
export function pdfhref(params) {
    return request({
        url: 'pdf/upload_history/',
        method: 'get',
        params
    })
}
export function getpdfchuck(params) {
    return request({
        url: 'pdf/getpdfchuck/',
        method: 'get',
        params
    })
}

// export function question(params) {
//     return request({
//       url: 'chat_pdf/question/',
//       method: 'get',
//       responseType: 'stream', // 设置响应类型为流式数据
//       params
//     })
// }
// 注册用户
export function organ_user(params) {
    return request({
        url: 'pdf/organ_user/',
        method: 'post',
        data: params
    })
}
// 子用户登录
export function organ_user_login(params) {
    return request({
        url: '/personlogin/',
        method: 'post',
        data: qs.stringify(params)
    })
}

// 获取个人会话列表
export function group(params) {
    return request({
        url: 'pdf/group/',
        method: 'get',
        params
    })
}
//创建会话/修改会话名称
export function group_create(params) {
    return request({
        url: 'pdf/group/',
        method: 'post',
        data: params
    })
}
//会话添加文件
export function group_pdf(params) {
    return request({
        url: 'pdf/group_pdf/',
        method: 'post',
        data: params
    })
}
//删除会话
export function group_delete(params) {
    return request({
        url: 'pdf/group/',
        method: 'delete',
        params
    })
}

// 获取用户的上传记录
export function organ_user_pdf(params) {
    return request({
        url: 'pdf/organ_user_pdf/',
        method: 'get',
        params
    })
}
// 获取历史问答记录
export function question_history(params) {
    return request({
        url: 'pdf/question_history/',
        method: 'get',
        params
    })
}

// 获取excel 文本信息
export function upload_excel(params) {
    return request({
        url: 'pdf/upload_excel/',
        method: 'get',
        params
    })
}

// 获取默认问答
export function default_question(params) {
    return request({
        url: 'pdf/default_question/',
        method: 'get',
        params
    })
}
export function annex(params) {
    return request({
        url: 'pdf/annex/',
        method: 'get',
        params
    })
}

// 修改文件名
export function pdf_name(params) {
    return request({
        url: 'pdf/update_pdf/',
        method: 'get',
        params
    })
}
export function delete_pdf(params) {
    return request({
        url: 'pdf/delete_pdf/',
        method: 'get',
        params
    })
}

// 获取默认文件
export function default_file(params) {
    return request({
        url: 'pdf/default_file/',
        method: 'get',
        params
    })
}

// chatBooks
export function chatBooks(params) {
    return request({
        url: 'chatchinesebook/search/',
        method: 'post',
        data: params
    })
}

// bug意见反馈提交接口
export function bugFeedback(data) {
    return request({
        url: 'bugfeedback/',
        method: 'post',
        // data: params
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
// bug文件上传
export function uploadBug(params) {
    return request({
        url: 'uploadbugimg/',
        method: 'post',
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // },
        // data: qs.stringify(data),
        data: params
    })
}

// 测试申请
export function applyforUser(data) {
    return request({
        url: 'userapplyfor/',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
        // data: params
    })
}

export function gettoken() {
    return request({
        url: 'https://edge.microsoft.com/translate/auth',
        method: 'get',
    })
}

export function getTranslate(params,data,tokens) {
    return request({
        url: 'https://api-edge.cognitive.microsofttranslator.com/translate',
        method: 'post',
        data,
        params,
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokens}`
        }
    })
}